import { defaultSections, optionsDefaultSections, defaultPages } from "../data/default-sections";

const getGroupNameById = (groupId, groups) => {
  const search = (nodes) => {
    for (const node of nodes) {
      if (node.id === groupId) return node.label;
      if (node.children) {
          const found = search(node.children);
          if (found) return found;
      }
    }
    return null;
  };

  return groupId ? search(groups) : null;
}

const getListConfig = (type, configReport) => {
  const currentCodes = (configReport[type] || []).map(item => { return item.code });

  const buildItem = (item, isOptional = false) => ({
    id: isOptional ? 0 : item.id,
    code: item.code,
    name: item.name,
    description: item.description || null,
  });

  let list = [];
  if (type === 'sections') {
    list = [
      ...defaultSections.map(item => buildItem(item)),
      ...optionsDefaultSections.map(item => buildItem(item, true)),
    ];

    list.push({
      id: 0,
      code: 'DEFAULT',
      name: 'Sección personalizada',
      description: 'Esta sección permite al usuario agregar contenido personalizado al reporte'
    });
  }
  else {
    list = defaultPages.map(item => buildItem(item));
  }

  return list.filter(item => ! currentCodes.includes(item.code));
}

const readFileAsDataURL = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = (e) => reject(e);
    reader.readAsDataURL(file);
  });
}


export {
  getListConfig,
  getGroupNameById,
  readFileAsDataURL,
}